export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-global-line', description: '所有爆料资讯' },
  { slug: 'yule', name: '娱乐八卦', icon: 'ri-movie-2-line', description: '明星动态、影视圈内幕' },
  { slug: 'shehui', name: '社会热点', icon: 'ri-fire-line', description: '社会新闻、民生爆料' },
  { slug: 'keji', name: '科技数码', icon: 'ri-smartphone-line', description: '科技圈内幕、数码新品' },
  { slug: 'tiyu', name: '体育竞技', icon: 'ri-basketball-line', description: '体育赛事、转会内幕' },
  { slug: 'caijing', name: '财经内幕', icon: 'ri-money-cny-circle-line', description: '商业机密、股市动态' },
  { slug: 'qiche', name: '汽车圈', icon: 'ri-car-line', description: '新车爆料、行业黑幕' },
  { slug: 'meishi', name: '美食探店', icon: 'ri-restaurant-line', description: '网红美食、后厨揭秘' },
];